import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "vuetify/dist/vuetify.min.css";
import VueSession from "vue-session";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, confirmed, integer, min_value } from "vee-validate/dist/rules";

Vue.use(vuetify);
Vue.use(VueSession);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

extend("required", {
  ...required,
  message: "{_field_} is required.",
});
extend("confirmed", {
  ...confirmed,
  message: "Inputs don't match.",
});
extend("integer", {
  ...integer,
  message: "Please enter only integer for {_field_}",
});
extend("min_value", {
  ...min_value,
  message: "Please enter a value greater than or equal to 0 {_field_}",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
